import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  templateUrl:'./educationalformyearlySecondCol.component.html',
  providers: [ ConfirmationService]

})
export class EducationalFormYearSecndRowComponent implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  @Input()  enrollment_year_auto :number;
  @Input() specialisationlevel_auto: string;
  @Input() leaving_year_auto: number;
  @Input() seat_number: any;
  @Input() mu_seat_number: any;
  @Input() semester_auto : any

  validations_flag = false;
  feedback_message;
  showExperience = false;
  enrollYear = [];
  enrollment_year:any;
  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  classValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  endmonthValidation = true;
  endYearValidation = true;
  edu_data;
  course_data;
  user: any;
  semesterValidation = true;
  totalMarks: number;
  totalMarksOut: number;
  parcen: number;
  
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;

  specialInstructionArray = ['@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A',
    '& Scaled Down, Cir. No. UG/61 of 2013-2014',
    '+ Carried Forward Marks as per Ordinance of University of Mumbai',
    '* As per University of Mumbai Ordinance 0.5045a',
    '$ - Carried forward grade as per ordinance of the University of Mumbai',
    '# As per University of Mumbai, Ordinance 0.229'
  ]
  specialInstruction: any;
  specI: any;
  GradespecialInstruction: any;
  DradespecI: any;
  newcourse_code = [];

  course_name: any;
  edu_level: any;
  college_year: any;
  // semester_auto: any;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  isDisabled = false;
  startmonth;
  startYear: any;

  predictive_data;
  specialisation_data;
  specialisation_name: any;
  show_predictive: boolean =false;

  preEditFirst: boolean = false;
  preEditSecond: boolean = false;
  preEditThird: boolean = false;
  preEditFourth: boolean = false;
  preEditFifth: boolean = false;
  preEditSixth: boolean = false;
  preEditSeventh: boolean = false;
  preEditEight: boolean = false;
  preEditNinth: boolean = false;
  preEditTenth: boolean = false;

  editShow1 : boolean = false;
  editShow2 : boolean = false;
  editShow3 : boolean = false;
  editShow4 : boolean = false;
  editShow5 : boolean = false;
  editShow6 : boolean = false;
  editShow7 : boolean = false
  editShow8 : boolean = false;
  editShow9 : boolean = false;
  editShow10 : boolean = false;

  total_value1: number;
  total_value2: number;
  total_value3: number;
  total_value4: number;
  total_value5: number;
  total_value6: number;
  total_value7: number;
  total_value8: number;

  setMarksobt1 : any;
  setMarksobt2 : any;
  setMarksobt3 : any;
  setMarksobt4 : any;
  setMarksobt5 : any;
  setMarksobt6 : any;
  setMarksobt7 : any;
  setMarksobt8 : any;
  

  subjectPreName : any;
  subjectPreName2 : any;
  subjectPreName3 : any;
  subjectPreName4 : any;
  subjectPreName5 : any;
  subjectPreName6 : any;
  subjectPreName7 : any;
  subjectPreName8 : any;
  subjectPreName9 : any;
  subjectPreName10 : any;

  instruction1: boolean =false;                          
  instruction2: boolean =false;                          
  instruction3: boolean =false;                          
  instruction4: boolean =false;                          
  instruction5: boolean =false;                          
  instruction6: boolean =false;   

  special_instruction1: any = null;                          
  special_instruction2: any = null;                          
  special_instruction3: any = null;                          
  special_instruction4: any = null;                          
  special_instruction5: any = null;                          
  special_instruction6: any = null; 
  still_studying: any;
  stillStd: any;
  elective_Sub: any;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public toasterService: NbToastrService,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<EducationalFormYearSecndRowComponent>) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      overallclassCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      endyearCtrl: [''],
      endmonthCtrl: [''],
      stlStdmonthCtrl :  [''],
      overmarksobtCtrl: ['', Validators.required],
      overmarksoutCtrl: [''],
      subjectFirstCtrl: [''],
      markFirstCtrl: ['', Validators.required],
      markFirstOutCtrl: [''],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],

      firstInternalCtrl: [''],
      secondInternalCtrl: [''],
      thirdInternalCtrl: [''],
      fourthInternalCtrl: [''],
      fifthInternalCtrl: [''],
      sixthInternalCtrl: [''],
      sevenInternalCtrl: [''],
      eighthInternalCtrl: [''],

      FirstTotalCtrl : [ ''],
      SecondTotalCtrl : [''],
      ThirdTotalCtrl : [''],
      FourthTotalCtrl : [''],
      FifthTotalCtrl : [''],
      SixthTotalCtrl : [''],
      SeventhTotalCtrl : [''],
      EightTotalCtrl : [''],

      instructionCtrl: ['', Validators.required],
      
      specialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
      percentageCtrl: ['', Validators.required],
      overAllGradeCtrl:[''],
      
      semesterCtrl: ['', Validators.required],
      startyearCtrl: [''],
      SpecialisationCtrl :[''],
      seatNumberCtrl: [ '' , Validators.required],

      subjectEditFirstCtrl : [ '' ],
      subjectEditSecondCtrl : [ '' ],
      subjectEditThirdCtrl : [ '' ],
      subjectEditFourthCtrl : [ '' ],
      subjectEditFifthCtrl : [ '' ],
      subjectEditSixthCtrl : [ '' ],
      subjectEditSeventhCtrl : [ '' ],
      subjectEditEightCtrl : [ '' ],
      subjectEditNinthCtrl : [ '' ],
      subjectEditTenthCtrl : [ '' ],

      remarksCtrl : [''],
      resultCtrl : [''],
      electivesubCtrl:[''],
      totaltwosemaddCtrl:[''],
 
    })

    if (this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo') {
      this.college_year = 'First';
      if (this.college_year_auto == 'SemesterOne') {
        this.semester_auto = 'I';
      } else {
        this.semester_auto = 'II';
      }
    } else if (this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour') {
      this.college_year = 'Second';
      if (this.college_year_auto == 'SemesterThree') {
        this.semester_auto = 'III';
      } else {
        this.semester_auto = 'IV';
      }
    } else if (this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix') {
      this.college_year = 'Third';
      if (this.college_year_auto == 'SemesterFive') {
        this.semester_auto = 'V';
      } else {
        this.semester_auto = 'VI';
      }
    }

     


    this.api.getStillStudying(this.user_id)
    .subscribe(
      (data: any) => {
        
        if (data['status'] == 200) {
          this.still_studying = data['data'];
          
          
          this.stillStd = this.still_studying.stillStudying;
          
        } else {

        }
      });

    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];
            if (this.course_name_auto != null) {
              this.course_data.forEach(element => {
                if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
                  this.course_name = element.CourseShortForm;
                  this.edu_level = element.type;
                }
              });
            }
           
          } else {

          }

          this.api.getCouseCode('sem',this.course_name,this.semester_auto, null).subscribe((data: any) => {
            if (data["status"] == 200) {
              
              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
              });
              
              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
              });
              
              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });

              
      
              
            } else {
            }
          });

        });

        this.api.getAllSpecialisation()
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.specialisation_data = data['data'];
              if (this.specialisationlevel_auto != null) {
                this.specialisation_data.forEach(element => {
                  
                  if (element.specialisation_name == this.specialisationlevel_auto) {
                    this.specialisation_name = element.specialisation_name;
                  }
                });
              }
             
            } else {
    
            }
          });

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    for(let info of this.years_array){
      if(info >= this.enrollment_year_auto){
        this.enrollYear.push(info)
       }
    } this.getEduDetails()
  }
  getEduDetails(){
    
    
    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];

              if(this.edu_data.special_instruction1){
                this.instruction1=true;
                this.special_instruction1 =this.edu_data.special_instruction1;
              }else{
                this.instruction1=false;
                this.special_instruction1 =null;
              }
              if(this.edu_data.special_instruction2){
                this.instruction2=true;
                this.special_instruction2 =this.edu_data.special_instruction2;
              }else{
                this.instruction2=false;
                this.special_instruction2 =null;
              }
              if(this.edu_data.special_instruction3){
                this.instruction3=true;
                this.special_instruction3 =this.edu_data.special_instruction3;
              }else{
                this.instruction3=false;
                this.special_instruction3 =null;
              } 
              if(this.edu_data.special_instruction4){
                this.instruction4=true;
                this.special_instruction4 =this.edu_data.special_instruction4;
              }else{
                this.instruction4=false;
                this.special_instruction4 =null;
              } 
              if(this.edu_data.special_instruction5){
                this.special_instruction5 =this.edu_data.special_instruction5;
                this.instruction5=true;
              }else{
                this.instruction5=false;
                this.special_instruction5 =null;
              } 
              if(this.edu_data.special_instruction6){
                this.instruction6=true;
                this.special_instruction6 =this.edu_data.special_instruction6;
              }else{
                this.instruction6=false;
                this.special_instruction6 =null;
              }

              this.course_name = this.edu_data.CourseName;
              this.college_year = this.edu_data.CollegeYear;
              this.semester_auto = this.edu_data.Semester;
              this.enrollment_year = this.edu_data.Year;
              this.specialisation_name = this.edu_data.specialisation;
              if(this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined){
                this.showcodeDropdown = false
                
              }else{
                
                this.showcodeDropdown = true
              }
              if(this.edu_data.Subject_Second != null){
                this.showcodeDropdown2 = false
                
              }else{
                
                this.showcodeDropdown2 = true
              }
              if(this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined){
                this.showcodeDropdown3 = false
                
              }else{
                
                this.showcodeDropdown3 = true
              }
              if(this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined){
                this.showcodeDropdown4 = false
                
              }else{
                
                this.showcodeDropdown4 = true
              }
              if(this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined){
                this.showcodeDropdown5 = false
                
              }else{
                
                this.showcodeDropdown5 = true
              }
              if(this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined){
                this.showcodeDropdown6 = false
                
              }else{
                
                this.showcodeDropdown6 = true
              }
              if(this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined){
                this.showcodeDropdown7 = false
                
              }else{
                
                this.showcodeDropdown7 = true
              }
              if(this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined){
                this.showcodeDropdown8 = false
                
              }else{
                
                this.showcodeDropdown8 = true
              }
  
              if(this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined){
                this.showcodeDropdown9 = false
                
              }else{
                
                this.showcodeDropdown9 = true
              }
              if(this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined){
                this.showcodeDropdown10 = false
                
              }else{
                
                this.showcodeDropdown10 = true
              }
             
            } else {
              
            }
          });
    } else {
      
    }
  }
  stillStudy(stillStudy: any) {
    throw new Error('Method not implemented.');
  }

  changeValue(value:any){
    
    
    
    if(value){
      this.api.getPredictiveCourse('sem',this.course_name_auto, this.semester_auto, value, this.college_year,this.specialisationlevel_auto).
      subscribe((data : any)=>{
        
        if(data['status'] == 200){
          this.predictive_data = data['data'];
          
            this.predictive_data.forEach(element => {
              
              this.subjectPreName = element.Subject_First;
              this.subjectPreName2 = element.Subject_Second;
              this.subjectPreName3 = element.Subject_Third
              this.subjectPreName4 = element.Subject_Fourth;
              this.subjectPreName5 = element.Subject_Fifth;
              this.subjectPreName6 = element.Subject_Six
              this.subjectPreName7 = element.Subject_Seventh;
              this.subjectPreName8 = element.Subject_Eighth;
              this.subjectPreName9 = element.Subject_Ninth;
              this.subjectPreName10 = element.Subject_Tenth;

              this.setMarksobt1 = element.marks_out_First;
              this.setMarksobt2 = element.marks_out_Second;
              this.setMarksobt3 = element.marks_out_Third;
              this.setMarksobt4 = element.marks_out_Fourth;
              this.setMarksobt5 = element.marks_out_Fifth;
              this.setMarksobt6 = element.marks_out_Six;
              this.setMarksobt7 = element.marks_out_Seventh;
              this.setMarksobt8 = element.marks_out_Eighth;


              
                  if(value == element.Year){
                  this.show_predictive = true;
                   
              }
            });
          
        }
          else{
            this.show_predictive = false;
                    
                    this.api.getCouseCodeNew('sem',this.course_name_auto, this.semester_auto, this.specialisationlevel_auto,this.college_year, null)
                    .subscribe(
                      (data: any) => {
                        if (data['status'] == 200) {
                          this.autocheck = false
                          this.filterText = "";
                          this.course_code = data['data'];
                          
                          this.filterInput
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText =   term;
                
                            });
                            this.course_code2 = data['data']
                            this.filterInput2
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText2 =   term;
                
                            });
                
                            this.course_code3 = data['data']
                            this.filterInput3
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText3 =   term;
                
                            });
                            this.course_code4 = data['data']
                            this.filterInput4
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText4 =   term;
                
                            });
                            this.course_code5 = data['data']
                            this.filterInput5
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText5 =   term;
                
                            });
                            this.course_code6 = data['data']
                            this.filterInput6
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText6 =   term;
                
                            });
                            this.course_code7 = data['data']
                            this.filterInput7
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText7 =   term;
                
                            });
                            this.course_code8 = data['data']
                            this.filterInput8
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText8 =   term;
                
                            });
                            this.course_code9 = data['data']
                            this.filterInput9
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText9 =   term;
                
                            });
                            this.course_code10 = data['data']
                            this.filterInput10
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText10 =   term;
                
                            });
                        }         
          })
      }
    });   
  } 
}

  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value
    var count = 0
    this.newcourse_code = [];
    this.course_code.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code
      }
    })
   
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value

  }

  getCourse3(value) {
    this.subjectName3 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value
  }

  getCourse4(value) {

    this.subjectName4 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event: any) {
    
    this.withoutCodeSub4 = event.target.value

  }

  getCourse5(value) {

    this.subjectName5 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code6.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value

  }

  getCourse6(value) {

    this.subjectName6 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value

  }

  getCourse7(value) {

    this.subjectName7 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject8(event: any) {
    
    this.withoutCodeSub8 = event.target.value

  }
  getCourse8(value) {

    this.subjectName8 = value
    
  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value

  }
  getCourse10(value) {

    this.subjectName10 = value
    
  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value

  }
  getCourse9(value) {

    this.subjectName9 = value
    
  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value

  }

  editDropdownAdmin(){
    this.showcodeDropdown = true
    // this.preEditFirst = true;
    // this.editShow1 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
  .subscribe(
    (data: any) => { 
      
      if(data['status'] == 200){
       // this.autocheck = false
        this.course_code2 = data['data']
        this.filterText2 = "";
          this.filterInput2
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          this.filterText2 = term;
          //this.filterText2 = term;
        });
        
     
        
      }else{

      }
  });
  }

  editDropdownAdmin2(){
    
    
    this.showcodeDropdown2 = true
    // this.preEditSecond = true;
    // this.editShow2 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText = "";
          this.course_code = info['data'];
          
          this.filterInput
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin3(){
    this.showcodeDropdown3 = true
    // this.preEditThird = true;
    // this.editShow3 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText3 = "";
          this.course_code3 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText3 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin4(){
    this.showcodeDropdown4 = true
    // this.preEditFourth = true;
    // this.editShow4 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText4 = "";
          this.course_code4 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText4 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin5(){
    this.showcodeDropdown5 = true
    // this.preEditFifth = true;
    // this.editShow5 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText5 = "";
          this.course_code5 = info['data'];
          
          this.filterInput5
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText5 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin6(){
    this.showcodeDropdown6 = true
    // this.preEditSixth = true;
    // this.editShow6 = false;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText6 = "";
          this.course_code6 = info['data'];
          
          this.filterInput6
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText6 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin7(){
    this.showcodeDropdown7 = true
    // this.preEditSeventh = true;
    // this.editShow7 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText7 = "";
          this.course_code7 = info['data'];
          
          this.filterInput7
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText7 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin8(){
    this.showcodeDropdown8 = true
    // this.preEditEight = true;
    // this.editShow8 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText8 = "";
          this.course_code8 = info['data'];
          
          this.filterInput8
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText8 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin9(){
    this.showcodeDropdown9 = true
    // this.preEditNinth = true;
    // this.editShow9 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText9 = "";
          this.course_code9 = info['data'];
          
          this.filterInput9
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText9 = term;
          });
          
        }else{

        }
  });
  }

  editDropdownAdmin10(){
    this.preEditTenth = true;
    // this.showcodeDropdown10 = true
    // this.editShow10 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText10 = "";
          this.course_code10 = info['data'];
          
          this.filterInput10
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText10 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown(){
    this.showcodeDropdown = true
    this.preEditFirst = true;
    this.editShow1 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
  .subscribe(
    (data: any) => { 
      
      if(data['status'] == 200){
       // this.autocheck = false
        this.course_code2 = data['data']
        this.filterText2 = "";
          this.filterInput2
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          this.filterText2 = term;
          //this.filterText2 = term;
        });
        
     
        
      }else{

      }
  });
  }

  editDropdown2(){
    
    
    this.showcodeDropdown2 = true
    this.preEditSecond = true;
    this.editShow2 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText = "";
          this.course_code = info['data'];
          
          this.filterInput
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText = term;
          });
          
        }else{

        }
  });
  }

  editDropdown3(){
    this.showcodeDropdown3 = true
    this.preEditThird = true;
    this.editShow3 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText3 = "";
          this.course_code3 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText3 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown4(){
    this.showcodeDropdown4 = true
    this.preEditFourth = true;
    this.editShow4 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText4 = "";
          this.course_code4 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText4 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown5(){
    this.showcodeDropdown5 = true
    this.preEditFifth = true;
    this.editShow5 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText5 = "";
          this.course_code5 = info['data'];
          
          this.filterInput5
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText5 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown6(){
    this.showcodeDropdown6 = true
    this.preEditSixth = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText6 = "";
          this.course_code6 = info['data'];
          
          this.filterInput6
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText6 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown7(){
    this.showcodeDropdown7 = true
    this.preEditSeventh = true;
    this.editShow7 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText7 = "";
          this.course_code7 = info['data'];
          
          this.filterInput7
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText7 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown8(){
    this.showcodeDropdown8 = true
    this.preEditEight = true;
    this.editShow8 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText8 = "";
          this.course_code8 = info['data'];
          
          this.filterInput8
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText8 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown9(){
    this.showcodeDropdown9 = true
    this.preEditNinth = true;
    this.editShow9 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText9 = "";
          this.course_code9 = info['data'];
          
          this.filterInput9
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText9 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown10(){
    this.preEditTenth = true;
    this.showcodeDropdown10 = true
    this.editShow10 = true;
    this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText10 = "";
          this.course_code10 = info['data'];
          
          this.filterInput10
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText10 = term;
          });
          
        }else{

        }
  });
  }

  // editDropdown9(){
  //   this.showcodeDropdown9 = true
  //   this.preEditNinth = true;
  //   this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
  //   .subscribe(
  //     (info: any) => { 
  
  //       if(info['status'] == 200){
  //         this.autocheck = false
  //         this.filterText9 = "";
  //         this.course_code9 = info['data'];
          
  //         this.filterInput9
  //           .valueChanges
  //           .debounceTime(200)
  //           .subscribe(term => {
  //           //this.filterText = term;
  //           this.filterText9 = term;
  //         });
  
  //       }else{

  //       }
  // });
  // }

  // editDropdown10(){
  //   this.showcodeDropdown10 = true
  //   this.preEditTenth = true;
  //   this.api.getCouseCodeEdit('sem',this.course_name_auto, this.semester_auto, this.specialisation_name, this.college_year, null)
  //   .subscribe(
  //     (info: any) => { 
  
  //       if(info['status'] == 200){
  //         this.autocheck = false
  //         this.filterText10 = "";
  //         this.course_code10 = info['data'];
          
  //         this.filterInput10
  //           .valueChanges
  //           .debounceTime(200)
  //           .subscribe(term => {
  //           //this.filterText = term;
  //           this.filterText10 = term;
  //         });
  
  //       }else{

  //       }
  // });
  // }

  onDeleteSubject(no){
    
    this.api.deleteRecords(this.user_id,this.edu_id,no)
    .subscribe(data => {
      if(data["status"]==200){
        this.getEduDetails();
        this.toasterService.success("Deleted successfully");
      }
    },
    (err)=>console.error(err)
    );
  }

  showContactDetails(){
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;'+' Whatsapp -  +91 99306 00066'  ,
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
                
      },
      reject: () => {
        
      }
    });
  }


  saveEdu() {
    
    
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.classValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.semesterValidation = true;
    this.endYearValidation = true;
    if(this.edu_form.controls.semesterCtrl.value){
      if(this.edu_form.controls.endmonthCtrl.value){
        this.startmonth = this.edu_form.controls.endmonthCtrl.value
      }else{
        if(this.edu_form.controls.semesterCtrl.value == 'I' || this.edu_form.controls.semesterCtrl.value ==  'III' || this.edu_form.controls.semesterCtrl.value == 'V'){
          this.startmonth = 'June'
        }else{
          this.startmonth =  'November'
        }
      }
      
    }

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.firstInternalCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.seatNumberCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.percentageCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.overallclassCtrl.value === null || this.edu_form.controls.overallclassCtrl.value === '' || this.edu_form.controls.overallclassCtrl.value === undefined) {
        this.classValidation = false;
      } else {
        this.classValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
      

      // if(this.edu_form.controls.endmonthCtrl.value === null || this.edu_form.controls.endmonthCtrl.value ==='' || this.edu_form.controls.endmonthCtrl.value ===undefined){
      //   this.endmonthValidation = false;
      // }else {
      //   this.endmonthValidation = true;
      // }

      // if(this.edu_form.controls.endyearCtrl.value === null || this.edu_form.controls.endyearCtrl.value ==='' || this.edu_form.controls.endyearCtrl.value ===undefined){
      //   this.endYearValidation = false;
      // }else {
      //   this.endYearValidation = true;
      // }
    } else {
      
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        overall_class: this.edu_form.controls.overallclassCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        endmonth: this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
        endYear: this.edu_form.controls.endyearCtrl.value,
        overall_marks_obt: this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        subjectPreFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        subjectPreSecond : this.edu_form.controls.subjectSecondCtrl.value,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        subjectPreThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        subjectPreFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        subjectPreFifth : this.edu_form.controls.subjectFifthCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        subjectPreSixth : this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        subjectPreSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        subjectPreEighth : this.edu_form.controls.subjectEighthCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        elective_Sub:this.edu_form.controls.electivesubCtrl.value,
        total_semVsemVI:this.edu_form.controls.totaltwosemaddCtrl.value,

       
       
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        overAllYearlyGrade: this.edu_form.controls.percentageCtrl.value,
        overAllGrade:this.edu_form.controls.overAllGradeCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        specialisation : this.edu_form.controls.SpecialisationCtrl.value,
        seat_number : this.edu_form.controls.seatNumberCtrl.value,

        internal_Marks : this.edu_form.controls.firstInternalCtrl.value,
        internal_Marks_Second : this.edu_form.controls.secondInternalCtrl.value,
        internal_Marks_Third : this.edu_form.controls.thirdInternalCtrl.value,
        internal_Marks_Fourth : this.edu_form.controls.fourthInternalCtrl.value,
        internal_Marks_Fifth : this.edu_form.controls.fifthInternalCtrl.value,
        internal_Marks_Sixth : this.edu_form.controls.sixthInternalCtrl.value,
        internal_Marks_Seventh : this.edu_form.controls.sevenInternalCtrl.value,
        internal_Marks_Eight : this.edu_form.controls.eighthInternalCtrl.value,

        first_total_marks : this.edu_form.controls.FirstTotalCtrl.value,
        second_total_marks : this.edu_form.controls.SecondTotalCtrl.value,
        third_total_marks : this.edu_form.controls.ThirdTotalCtrl.value,
        fourth_total_marks : this.edu_form.controls.FourthTotalCtrl.value,
        fifth_total_marks : this.edu_form.controls.FifthTotalCtrl.value,
        sixth_total_marks : this.edu_form.controls.SixthTotalCtrl.value,
        seventh_total_marks : this.edu_form.controls.SeventhTotalCtrl.value,
        eight_total_marks : this.edu_form.controls.EightTotalCtrl.value,

        special_instruction1 : this.special_instruction1,
        special_instruction2 : this.special_instruction2,
        special_instruction3 : this.special_instruction3,
        special_instruction4 : this.special_instruction4,
        special_instruction5 : this.special_instruction5,
        special_instruction6 : this.special_instruction6,

        subject_edit_First : this.edu_form.controls.subjectEditFirstCtrl.value.toUpperCase(),
        subject_edit_Second : this.edu_form.controls.subjectEditSecondCtrl.value.toUpperCase(),
        subject_edit_Third : this.edu_form.controls.subjectEditThirdCtrl.value.toUpperCase(),
        subject_edit_Fourth : this.edu_form.controls.subjectEditFourthCtrl.value.toUpperCase(),
        subject_edit_Fifth : this.edu_form.controls.subjectEditFifthCtrl.value.toUpperCase(),
        subject_edit_Sixth : this.edu_form.controls.subjectEditSixthCtrl.value.toUpperCase(),
        subject_edit_Seventh : this.edu_form.controls.subjectEditSeventhCtrl.value.toUpperCase(),
        subject_edit_Eight : this.edu_form.controls.subjectEditEightCtrl.value.toUpperCase(),
        subject_edit_Ninth : this.edu_form.controls.subjectEditNinthCtrl.value.toUpperCase(),
        subject_edit_Tenth : this.edu_form.controls.subjectEditTenthCtrl.value.toUpperCase(),
       


        result : this.edu_form.controls.resultCtrl.value,
        remarks : this.edu_form.controls.remarksCtrl.value,
        stillStdMonth : this.edu_form.controls.stlStdmonthCtrl.value,


      }


      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  hetmarksObt() {
    this.totalMarks = 0
    
    if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }
  }

  totalsMarksOut() {
    this.totalMarksOut = 0
    if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value) {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
    }

    if (this.totalMarksOut != null && this.totalMarksOut != undefined && this.totalMarks != null && this.totalMarks != undefined) {
      this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
      this.parcen = Number(this.parcen.toFixed(2))
      
    }
  }

  setMarksOutOf(){
    if(this.edu_form.controls.subjectFirstCtrl.value != null || this.edu_form.controls.subjectFirstCtrl.value != '' || this.edu_form.controls.subjectFirstCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt1 = 150;
      }
      else{
        this.setMarksobt1 = 100;
      }
    }
  }
  setMarksOutOf2(){
    if(this.edu_form.controls.subjectSecondCtrl.value != null || this.edu_form.controls.subjectSecondCtrl.value != '' || this.edu_form.controls.subjectSecondCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt2 = 150;
      }
      else{
        this.setMarksobt2 = 100;
      }
    }
  }
  setMarksOutOf3(){
    if(this.edu_form.controls.subjectThirdCtrl.value != null || this.edu_form.controls.subjectThirdCtrl.value != '' || this.edu_form.controls.subjectThirdCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt3 = 150;
      }else{
        this.setMarksobt3 = 100;
      }
    }
  }

  setMarksOutOf4(){
    if(this.edu_form.controls.subjectFourthCtrl.value != null || this.edu_form.controls.subjectFourthCtrl.value != '' || this.edu_form.controls.subjectFourthCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt4 = 150;
      }
      else{
      this.setMarksobt4 = 100;
      }
    }
  }
  setMarksOutOf5(){
    if(this.edu_form.controls.subjectFifthCtrl.value != null || this.edu_form.controls.subjectFifthCtrl.value != '' || this.edu_form.controls.subjectFifthCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt5 = 150;
      }
      else{
        this.setMarksobt5 = 100;
      }
    }
  }

  setMarksOutOf6(){
    if(this.edu_form.controls.subjectSixthCtrl.value != null || this.edu_form.controls.subjectSixthCtrl.value != '' || this.edu_form.controls.subjectSixthCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt6 = 150;
      }
      else{
        this.setMarksobt6 = 100;
      }
    }
  }

  setMarksOutOf7(){
    if(this.edu_form.controls.subjectSeventhCtrl.value != null || this.edu_form.controls.subjectSeventhCtrl.value != '' || this.edu_form.controls.subjectSeventhCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt7 = 150;
      }
      else {
        this.setMarksobt7 = 100;
      }
    }
  }
  setMarksOutOf8(){
    if(this.edu_form.controls.subjectEighthCtrl.value != null || this.edu_form.controls.subjectEighthCtrl.value != '' || this.edu_form.controls.subjectEighthCtrl.value != undefined){
      if(this.course_name =='B.Sc.IT'){
        this.setMarksobt8 = 150;
      }
      else {
        this.setMarksobt8 = 100;
      }
    }
  }
    
  outOfTotal(){
    this.totalMarks=0;
    this.totalMarksOut=0;
    
    if(this.edu_form.controls.firstInternalCtrl.value && this.edu_form.controls.markFirstCtrl.value){
      /* IF internal & written not null it will add and store in total_value1 */
      this.total_value1 = (Number(this.edu_form.controls.firstInternalCtrl.value) +  Number(this.edu_form.controls.markFirstCtrl.value))
      if(this.total_value1>0){
        /* IF Total obtained not null it will add total mark+ total value1 and store in to total obtained marks */
        this.totalMarks = this.totalMarks + this.total_value1;
        if(this.setMarksobt1>0){
          /** If marks out of not null it will add  totalMarksOut + setMarksobt1 and display in "out of" input filed */
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt1;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            /** if Total obtained marks and Out of not null it will calculate Percentage and display in Percentage input filed */
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.secondInternalCtrl.value && this.edu_form.controls.markSecondCtrl.value){
      this.total_value2 = (Number(this.edu_form.controls.secondInternalCtrl.value) +  Number(this.edu_form.controls.markSecondCtrl.value))
      if(this.total_value2>0){
        this.totalMarks = this.totalMarks + this.total_value2;
        if(this.setMarksobt2>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt2;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.thirdInternalCtrl.value && this.edu_form.controls.markThirdCtrl.value){
      this.total_value3 = (Number(this.edu_form.controls.thirdInternalCtrl.value) +  Number(this.edu_form.controls.markThirdCtrl.value))
      if(this.total_value3>0){
        this.totalMarks = this.totalMarks + this.total_value3;
        if(this.setMarksobt3>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt3;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.fourthInternalCtrl.value && this.edu_form.controls.markFourthCtrl.value){
      this.total_value4 = (Number(this.edu_form.controls.fourthInternalCtrl.value) +  Number(this.edu_form.controls.markFourthCtrl.value))
      if(this.total_value4>0){
        this.totalMarks = this.totalMarks + this.total_value4;
        if(this.setMarksobt4>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt4;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.fifthInternalCtrl.value && this.edu_form.controls.markFifthCtrl.value){
      this.total_value5 = (Number(this.edu_form.controls.fifthInternalCtrl.value) +  Number(this.edu_form.controls.markFifthCtrl.value))
      if(this.total_value5>0){
        this.totalMarks = this.totalMarks + this.total_value5;
        if(this.setMarksobt5>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt5;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.sixthInternalCtrl.value && this.edu_form.controls.markSixthCtrl.value){
      this.total_value6 = (Number(this.edu_form.controls.sixthInternalCtrl.value) +  Number(this.edu_form.controls.markSixthCtrl.value))
      if(this.total_value6>0){
        this.totalMarks = this.totalMarks + this.total_value6;
        if(this.setMarksobt6>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt6;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.sevenInternalCtrl.value && this.edu_form.controls.markSeventhCtrl.value){
      this.total_value7 = (Number(this.edu_form.controls.sevenInternalCtrl.value) +  Number(this.edu_form.controls.markSeventhCtrl.value))
      if(this.total_value7>0){
        this.totalMarks = this.totalMarks + this.total_value7;
        if(this.setMarksobt7>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt7;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
    if(this.edu_form.controls.eighthInternalCtrl.value && this.edu_form.controls.markEighthCtrl.value){
      this.total_value8 = (Number(this.edu_form.controls.eighthInternalCtrl.value) +  Number(this.edu_form.controls.markEighthCtrl.value))
      if(this.total_value8>0){
        this.totalMarks = this.totalMarks + this.total_value8;
        if(this.setMarksobt8>0){
          this.totalMarksOut = this.totalMarksOut+this.setMarksobt8;
          if(this.totalMarks>0 && this.totalMarksOut>0){
            this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
            this.parcen = Number(this.parcen.toFixed(2))
          }
        }
      }
    }
  }
    
  
  onChange(event,no) {
    if(no=='1'){
      if(event.checked == true){
        this.instruction1 = true;
        this.special_instruction1 = '@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A'
      }
      if(event.checked == false){
        this.instruction1 = false;
        this.special_instruction1 = null
      }
    }else if(no=='2'){
      if(event.checked == true){
        this.instruction2 = true;
        this.special_instruction2 = '& Scaled Down, Cir. No. UG/61 of 2013-2014'
      }
      if(event.checked == false){
        this.instruction2 = false;
        this.special_instruction2 = null
      }
    }else if(no=='3'){
      if(event.checked == true){
        this.instruction3 = true;
        this.special_instruction3 = '+ Carried Forward Marks as per Ordinance of University of Mumbai'
      }
      if(event.checked == false){
        this.instruction3 = false;
        this.special_instruction3 = null
      }
    }else if(no=='4'){
      if(event.checked == true){
        this.instruction4 = true;
        this.special_instruction4 = '* As per University of Mumbai Ordinance 0.5045a'
      }
       if(event.checked == false){
        this.instruction4 = false;
        this.special_instruction4 = null
      }
    }else if(no=='5'){
      if(event.checked == true){
        this.instruction5 = true;
        this.special_instruction5 = '$ - Carried forward grade as per ordinance of the University of Mumbai'
      }
      if(event.checked == false){
        this.instruction5 = false;
        this.special_instruction5 = null
      }
    }else if(no=='6'){
      if(event.checked == true){
        this.instruction6 = true;
        this.special_instruction6 = '# As per University of Mumbai, Ordinance 0.229'
      }
      if(event.checked == false){
        this.instruction6 = false;
        this.special_instruction6 = null
      }
    }
  }

  updateSpecialInstruction(val) {
    this.specialInstruction = val
  }

  getSpecialInst(event: any) {

    this.specialInstruction = event.target.value

  }

  updateGradeSpecialInstruction(val) {
    
    this.GradespecialInstruction = val
  }

  getGradeSpecialInst(event: any) {

    this.GradespecialInstruction = event.target.value

  }

  showcoursecodeDropdown() {
    this.showcodeDropdown = true;
  }
  
  showcoursecodeDropdown2() {
    this.showcodeDropdown2 = true;
  }
  
  showcoursecodeDropdown3() {
    this.showcodeDropdown3 = true;
  }
  
  showcoursecodeDropdown4() {
    this.showcodeDropdown4 = true;
  }
  
  showcoursecodeDropdown5() {
    this.showcodeDropdown5 = true;
  }
  
  showcoursecodeDropdown6() {
    this.showcodeDropdown6 = true;
  }
  
  showcoursecodeDropdown7() {
    this.showcodeDropdown7 = true;
  }
  
  showcoursecodeDropdown8() {
    this.showcodeDropdown8 = true;
  }
  
  showcoursecodeDropdown9() {
    this.showcodeDropdown9 = true;
  }
  
  showcoursecodeDropdown10() {
    this.showcodeDropdown10 = true;
  }


}